"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperaturePanelBackground = void 0;
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactErrorBoundary = require("react-error-boundary");
var _paulCorePackage = require("paul-core-package");
var _Types = require("../../../Types");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TemperaturePanelBackground = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    color,
    position = [0, 0, 0],
    scale = 1
  } = _ref;
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/panels/TemperaturePanel.glb"));
  return /*#__PURE__*/_react.default.createElement("group", {
    position: position,
    scale: scale,
    dispose: null
  }, /*#__PURE__*/_react.default.createElement("mesh", {
    geometry: nodes.Boarder.geometry,
    material: materials.BLUEDARK,
    position: [0, -2.61, -0.01],
    rotation: [Math.PI / 2, 0, -Math.PI / 2]
  }, /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: color
  })), /*#__PURE__*/_react.default.createElement("mesh", {
    geometry: nodes.Textfield.geometry,
    material: materials.WHITE,
    position: [0, -2.61, -0.01],
    rotation: [Math.PI / 2, 0, -Math.PI / 2]
  }, /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#00205B",
    transparent: "true",
    opacity: 0.5
  })), /*#__PURE__*/_react.default.createElement("mesh", {
    geometry: nodes.Box.geometry,
    material: materials.BLUENEON,
    position: [0, -0.01, -0.01],
    rotation: [Math.PI / 2, 0, -Math.PI / 2]
  }, /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: color,
    doubleSided: "true"
  })));
}, (prev, next) => prev.color === next.color && prev.position === next.position && prev.scale === next.scale);
TemperaturePanelBackground.propTypes = {
  color: _propTypes.default.string,
  scale: _propTypes.default.number,
  position: _Types.VectorType
};
const TemperaturePanelBackgroundBoundary = exports.TemperaturePanelBackground = (0, _reactErrorBoundary.withErrorBoundary)(TemperaturePanelBackground, {
  FallbackComponent: () => null,
  // eslint-disable-next-line no-console
  onError: (err, info) => console.error(err, info)
});